export const ADD_ATTENDEES = 'app/DeedPage/AddAttendeesOverlay/ADD_ATTENDEES';
export const ADD_ATTENDEES_SUCCESS = 'app/DeedPage/AddAttendeesOverlay/ADD_ATTENDEES_SUCCESS';
export const ADD_ATTENDEES_FAILED = 'app/DeedPage/AddAttendeesOverlay/ADD_ATTENDEES_FAILED';

export const SEARCH = 'app/DeedPage/AddAttendeesOverlay/SEARCH';
export const SEARCH_SUCCESS = 'app/DeedPage/AddAttendeesOverlay/SEARCH_SUCCESS';
export const SEARCH_FAILED = 'app/DeedPage/AddAttendeesOverlay/SEARCH_FAILED';

export const CLEAR = 'app/DeedPage/AddAttendeesOverlay/CLEAR';
